import { environmentDevelopment } from './environment.development';
import { environmentLocal } from './environment.local';
import { environmentProduction } from './environment.production';

let environmentTemp: {
  version?: string;
  name: string;
  production: boolean;
  sentry: string;
  mixpanel: string;
  googleAnalyticsTrackingId: string;
  facebookAppId: string;
  recaptchaSiteKey: string;
};

if (typeof window !== 'undefined') {
  if (window.location.host.startsWith('localhost:')) {
    environmentTemp = environmentLocal;
  } else if (window.location.host === 'app.devsandpit.com') {
    environmentTemp = environmentDevelopment;
  } else {
    environmentTemp = environmentProduction;
  }
} else if (typeof process !== 'undefined') {
  if (process.env.NODE_ENV === 'development') {
    environmentTemp = environmentDevelopment;
  } else {
    environmentTemp = environmentProduction;
  }
} else {
  throw new Error(
    'Could not determine if in browser or server in environment.'
  );
}

const environmentTemp2 = {
  ...environmentTemp,
  version: '0.5.1',
};

export const environment = environmentTemp2;
